import api from '@/api'
import { cloneDeep } from 'lodash'
import moment from 'moment'
import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'
import stateConfig from './config'

Vue.use(VueLocalStorage)

export default {
  setLang: function({ commit }, payload) {
    commit(stateConfig.SET_LANG, payload)
  },
  loading: function({ commit, state }) {
    commit(stateConfig.LOADING)
  },
  login: function({ commit, state }, creds) {
    commit(stateConfig.LOGIN) // show spinner
    return new Promise(async (resolve, reject) => {
      try {
        var response = await api.authDefault(creds)

        if (response.responsecode === 400) {
          resolve({
            code: response.responsecode,
            reason: response.reason
          })
        } else if (response.responsecode === 200) {
          state.botlist = response.botlist
          state.userid = creds.userid
          state.isFacebook = false
          state.loginChannel = 'account'
          state.accessToken = response.sessiontoken

          Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
          Vue.localStorage.set('userid', state.userid)
          Vue.localStorage.set('token', state.accessToken)
          Vue.localStorage.set('FB', state.isFacebook)
          Vue.localStorage.set('loginChannel', state.loginChannel)

          commit(stateConfig.LOGIN_SUCCESS)
          resolve({
            code: response.responsecode
          })
        } else {
          // console.log('hi')
        }
      } catch (error) {
        commit(stateConfig.LOGIN_FAIL)
        // console.log('error')
        reject(error)
      }
    })
  },
  loginFB: function({ commit, state, dispatch }, creds) {
    commit(stateConfig.LOGIN)
    return new Promise((resolve, reject) => {
      api.getLongLiveToken(creds, function(error, response) {
        if (error) {
          commit(stateConfig.LOGIN_FAIL)
          reject(error)
          return
        }

        api.getPageList({ token: response.longlivetoken }, function(
          errorPageList,
          responsePageList
        ) {
          if (errorPageList) {
            commit(stateConfig.LOGIN_FAIL)
            reject(new Error(error))
          }

          let pagelist = []
          if (responsePageList) {
            responsePageList.map(function(page, index) {
              pagelist.push(page.id)
            })
          }

          state.userid = creds.userid
          state.pagelist = responsePageList
          state.fbAccessToken = response.longlivetoken
          state.isFacebook = true
          state.loginChannel = creds.channel
          state.fbScope = creds.scope

          Vue.localStorage.set('fbtoken', state.fbAccessToken)
          Vue.localStorage.set('userid', state.userid)
          Vue.localStorage.set('pagelist', JSON.stringify(state.pagelist))
          Vue.localStorage.set('FB', state.isFacebook)
          Vue.localStorage.set('loginChannel', state.loginChannel)
          Vue.localStorage.set('fbScope', state.fbScope)
          let data = {
            userid: creds.userid,
            pageidlist: pagelist,
            access_token: state.fbAccessToken
          }
          dispatch('getBotlist', data).then(
            response => {
              commit(stateConfig.LOGIN_SUCCESS)
              resolve()
            },
            error => {
              commit(stateConfig.LOGIN_FAIL)
              reject(error)
            }
          )
        })
      })
    })
  },
  updateNewBotlist: function({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      let pagelist = []
      if (state.pagelist) {
        state.pagelist.map(function(value, index) {
          pagelist.push(value.id)
        })
      }

      let data = {
        userid: state.userid,
        pageidlist: pagelist,
        access_token: state.fbAccessToken
      }
      dispatch('getBotlist', data).then(
        response => {
          // commit(stateConfig.LOGIN_SUCCESS)
          if (state.selectedBot != null) {
            if (state.botlist) {
              state.botlist.map(function(val) {
                if (val.pageid === state.selectedBot.pageid) {
                  dispatch('selectBot', val)
                  return false
                }
              })
            }
          }
          resolve()
        },
        error => {
          // commit(stateConfig.LOGIN_FAIL)
          reject(error)
        }
      )
    })
  },
  getBotlist: function({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      api.checkBotlist(data, function(error, response) {
        if (error) {
          reject(new Error(error))
        }

        // console.log(response)

        if (response.pageidlist) {
          let botlist = response.botlist
          state.botlist = botlist
          state.accessToken = response.sessiontoken

          Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
          Vue.localStorage.set('token', state.accessToken)
        }
        resolve()
      })
    })
  },
  logout: function({ commit, state }, error) {
    return new Promise((resolve, reject) => {
      Vue.localStorage.remove('token')
      Vue.localStorage.remove('userid')
      Vue.localStorage.remove('botlist')
      Vue.localStorage.remove('selectedBot')
      Vue.localStorage.remove('fbtoken')
      // Vue.localStorage.remove('FB')
      Vue.localStorage.remove('pagelist')

      state.userid = null
      state.botlist = null
      state.selectedBot = null
      state.isSelectedBot = false
      // state.isFacebook = false
      state.accessToken = null
      state.fbAccessToken = null
      state.pagelist = null
      if (error) {
        state.systemError = error
      }
      // eslint-disable-next-line no-undef
      if ($('.modal-backdrop')) {
        // eslint-disable-next-line no-undef
        $('.modal-backdrop').remove()
      }
      commit(stateConfig.LOGOUT)

      resolve()
    })
  },
  selectBot: function({ state, commit, dispatch }, bot) {
    if (state.selectedBot && bot && bot.pageid !== state.selectedBot.pageid) {
      dispatch('updatePaypalTrackingId', null)
    }
    Vue.localStorage.set('selectedBot', JSON.stringify(bot))
    commit(stateConfig.SELECT_NEW_BOT, bot)
    commit(stateConfig.SELECT_BOT)
  },
  unselectBot: function({ state, commit, dispatch }) {
    dispatch('updatePaypalTrackingId', null)
    Vue.localStorage.remove('selectedBot')
    state.selectedBot = null
    state.isSelectedBot = false
  },
  updateBotlist: function({ state, commit }, botlist) {
    state.botlist = botlist
    Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
  },
  updatePagelist: function({ state, commit }) {
    if (!state.isFacebook) {
      return false
    }
    api.getPageList({ token: state.fbAccessToken }, function(error, response) {
      if (error) {
        console.error(error)
        return false
      }

      state.pagelist = response
      Vue.localStorage.set('pagelist', JSON.stringify(state.pagelist))

      return true
    })
  },
  sidebar: function({ commit, state }, value) {
    if (value) {
      // console.log(value)
      commit(stateConfig.SIDEBAR)
    }
    commit(stateConfig.SIDEBAR)
  },
  updatePaypalTrackingId: function({ commit, state }, value) {
    state.paypalTrackingId = value
    if (value == null) {
      Vue.localStorage.remove('paypalTrackingId')
    } else {
      Vue.localStorage.set('paypalTrackingId', state.paypalTrackingId)
    }
  },
  updateMerchantId: function({ commit, state }, value) {
    state.selectedBot.paypal_merchantid = value
    Vue.localStorage.set('selectedBot', JSON.stringify(state.selectedBot))
    commit(stateConfig.SELECT_NEW_BOT, state.selectedBot)
    commit(stateConfig.SELECT_BOT)
  },
  updateSetting: function({ commit, state }, value) {
    commit(stateConfig.UPDATE_SETTING, value)
  },
  updateWelcomeMessage: function({ commit, state }, value) {
    commit(stateConfig.UPDATE_WELCOME_MESSAGE, value)
  },
  updateBotDetail: function({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      let data = { pageid: state.selectedBot.pageid }
      api.getBotDetail(data, function(error, response) {
        if (error) {
          reject(error)
          return
        }

        if (response.data) {
          state.selectedBot.description = response.data.description
          state.selectedBot.expireat = response.data.expireat
          state.selectedBot.notify_admin = response.data.notify_admin
          state.selectedBot.ownerid = response.data.ownerid
          state.selectedBot.pageaddress = response.data.pageaddress
          state.selectedBot.pagelogo = response.data.pagelogo
          state.selectedBot.pagename = response.data.pagename
          state.selectedBot.pageshortlink = response.data.pageshortlink
          state.selectedBot.paypal_merchantid = response.data.paypal_merchantid
          state.selectedBot.persistent_menu = response.data.persistent_menu
          state.selectedBot.registerat = response.data.registerat
          state.selectedBot.status = response.data.status
          state.selectedBot.theme = response.data.theme
          state.selectedBot.packages = response.data.packages
          state.selectedBot.notify_comment = response.data.notify_comment
          state.selectedBot.notify_intent = response.data.notify_intent
          state.selectedBot.notify_neworder = response.data.notify_neworder
          state.selectedBot.notify_payment = response.data.notify_payment
          state.selectedBot.supportusers = response.data.supportusers

          Vue.localStorage.set('selectedBot', JSON.stringify(state.selectedBot))
          if (state.botlist) {
            state.botlist.map(function(bot, index) {
              if (bot.pageid === state.selectedBot.pageid) {
                state.botlist[index] = state.selectedBot
                Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
                return false
              }
            })
          }
        }

        resolve(response)
      })
    })
  },
  addModalWelcome: function({ commit, state }) {
    commit(stateConfig.UPDATE_MODAL_WELCOME, true)
  },
  clearModalWelcome: function({ commit, state }) {
    commit(stateConfig.UPDATE_MODAL_WELCOME, false)
  },
  clearAlert: function({ state, commit }, name) {
    var pageid = null
    if (state.selectedBot) {
      pageid = state.selectedBot.pageid
    }
    commit(stateConfig.UPDATE_ALERT, { name: name, show: false, pageid: pageid })
  },
  getSetting: function({ state }) {
    return new Promise((resolve, reject) => {
      api.getSetting({ pageid: state.selectedBot.pageid }, function(error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.data) {
          resolve(response.data)
        } else {
          reject()
        }
      })
    })
  },
  loadSetting: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.loadingSetting = true
      dispatch('getSetting').then(
        setting => {
          var contents = []
          setting.map(function(content, index) {
            contents[content.contenttype] = content
          })
          state.setting = contents
          state.loadingSetting = false
          resolve()
        },
        error => {
          console.error(error)
          state.loadingSetting = false
          reject(error)
        }
      )
    })
  },
  getApiList: function({ state }) {
    return new Promise((resolve, reject) => {
      api.getApiList(null, function(error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.data) {
          resolve(response.data)
        } else {
          reject()
        }
      })
    })
  },
  loadApiList: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.loadingApiList = true
      dispatch('getApiList').then(
        api => {
          state.apiList = api
          state.loadingApiList = false
          resolve()
        },
        error => {
          console.error(error)
          state.loadingApiList = false
          reject(error)
        }
      )
    })
  },
  getFlowList: function({ state }, options) {
    return new Promise((resolve, reject) => {
      var data = {
        adminid: state.userid,
        pageid: state.selectedBot.pageid,
        ...options
      }
      api.getFlowList(data, function(error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.data) {
          resolve(response.data)
        } else {
          reject()
        }
      })
    })
  },
  loadFlowList: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.loadingFlowList = true
      dispatch('getFlowList').then(
        flow => {
          state.flowList = flow ? flow : []
          state.loadingFlowList = false
          resolve()
        },
        error => {
          console.error(error)
          state.loadingFlowList = false
          reject(error)
        }
      )
    })
  },
  getAllVariable({}) {
    return new Promise((resolve, reject) => {
      var data = null
      api.getAllVariable(data, function(error, response) {
        if (error) {
          reject(error)
          return
        }
        if (response.data) {
          resolve(response.data)
        } else {
          reject()
        }
      })
    })
  },
  loadAllVariable: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.loadingVariableList = true
      dispatch('getAllVariable').then(
        variables => {
          state.variableList = variables ? variables : []
          state.loadingVariableList = false
          resolve()
        },
        error => {
          console.error(error)
          state.loadingVariableList = false
          reject(error)
        }
      )
    })
  },
  setFlowID: function({ commit }, payload) {
    commit(stateConfig.SET_FLOW_ID, payload)
  },
  setCopyNode: function({ commit }, payload) {
    commit(stateConfig.SET_COPY_NODE, payload)
  },
  getAllAdmins({}) {
    return new Promise((resolve, reject) => {
      var data = null
      api.getAllAdmins(data).then(response => {
        if (response.data) {
          resolve(response.data)
        } else {
          reject()
        }
      })
    })
  },
  loadAllAdmins: function({ state, dispatch, commit }) {
    return new Promise((resolve, reject) => {
      state.loadingAdminList = true
      dispatch('getAllAdmins').then(
        admins => {
          commit('SET_ADMIN_LIST', admins ? admins : [])

          state.loadingAdminList = false
          resolve()
        },
        error => {
          console.error(error)
          state.loadingAdminList = false
          reject(error)
        }
      )
    })
  },
  getAllBotOrigins({}) {
    return new Promise((resolve, reject) => {
      var data = null
      api.getAllBotOrigins(data).then(response => {
        if (response.data) {
          resolve(response.data)
        } else {
          reject()
        }
      })
    })
  },
  loadAllBotOrigins: function({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      state.loadingBotOrigins = true
      dispatch('getAllBotOrigins').then(
        botlist => {
          state.botOrigins = botlist ? botlist : []
          state.loadingBotOrigins = false
          resolve()
        },
        error => {
          console.error(error)
          state.loadingBotOrigins = false
          reject(error)
        }
      )
    })
  },
  getPersistentMenu({ state }) {
    return new Promise((resolve, reject) => {
      var data = {
        botorigin: state.selectedBot.pageid
      }

      api.getPersistentMenu(data).then(response => {
        if (response.data) {
          resolve(response.data)
        } else {
          reject(response.error)
        }
      })
    })
  },
  loadPersistentMenu: function(
    { state, dispatch, commit, getters },
    { pageid, isForceLoad = false }
  ) {
    return new Promise((resolve, reject) => {
      state.loadingPersistentMenu = true
      const date = moment().format('YYYYMMDD')
      const persistent_menu_key = `persistent_menu_${pageid}_${date}`
      if (!isForceLoad && localStorage.getItem(persistent_menu_key)) {
        try {
          const actions = JSON.parse(localStorage.getItem(persistent_menu_key))
          commit('SET_PERSISTENT_MENU', actions)
        } catch (error) {
          console.error(error)
          commit('SET_PERSISTENT_MENU', [])
        }

        state.loadingPersistentMenu = false
        resolve()
      } else {
        dispatch('getPersistentMenu').then(
          persistent_menu => {
            try {
              const actions = persistent_menu[0].persistent_menu[0].call_to_actions
              localStorage.setItem(persistent_menu_key, JSON.stringify(actions))
              commit('SET_PERSISTENT_MENU', actions)
            } catch (error) {
              localStorage.removeItem(persistent_menu_key)
              commit('SET_PERSISTENT_MENU', [])
            }

            state.loadingPersistentMenu = false
            resolve()
          },
          async error => {
            if (error && error.message) console.error(error.message)
            await Vue.swal.fire({
              type: 'error',
              title: 'Error',
              text: error.message
            })
            console.error(error)
            state.loadingPersistentMenu = false
            reject(error)
          }
        )
      }
    })
  },
  savePersistentMenu({ state, commit }, payload) {
    return new Promise((resolve, reject) => {
      state.loadingPersistentMenu = true

      var persistent = cloneDeep(payload)
      persistent = persistent.map(el => {
        return Object.fromEntries(
          Object.entries(el).filter(([key, val]) =>
            ['type', 'title', 'payload', 'webview_height_ratio', 'url'].includes(key)
          )
        )
      })

      var data = {
        params: {
          botorigin: state.selectedBot.pageid
        },
        data: {
          persistent_menu: [
            {
              locale: 'default',
              composer_input_disabled: false,
              call_to_actions: persistent
            }
          ]
        }
      }
      api.savePersistentMenu(data).then(response => {
        state.loadingPersistentMenu = false
        if (response) {
          if (response.responsecode == 200) {
            commit('SET_PERSISTENT_MENU', payload)
          }
          resolve(response)
        } else {
          reject()
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js